import React from 'react';
import styled from 'styled-components';

const CircleGraphStyles = styled.div`
  width: ${({ $size }) => ($size ? $size : '40px')};
  height: ${({ $size }) => ($size ? $size : '40px')};
  border-radius: 50%;
  background: var(--white);
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  .progress {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    /* background: linear-gradient(180deg, #1edce3 0%, #2783ec 100%); */
    background: #8b91b9;
    -webkit-mask: conic-gradient(#000 calc(var(--percentage) * 1%), transparent 0);
    mask: conic-gradient(#000 calc(var(--percentage) * 1%), transparent 0);
    padding: 2px;
    transition: 0.5s all ease-in-out;
  }
  .value-wrap {
    border-radius: 50%;
    background: ${({ $bg }) => ($bg ? $bg : 'var(--white)')};
    z-index: 10;
    position: absolute;
    inset: 3px;
    font-weight: 400;
    font-size: 10px;
    line-height: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--primary);
  }
`;

const CircleGraph = ({ size, value, bg, noPercentage }) => {
  return (
    <CircleGraphStyles $size={size} $bg={bg}>
      <div class="progress" style={{ '--percentage': value }}></div>
      <div className="value-wrap">
        {value}
        {!noPercentage && '%'}
      </div>
    </CircleGraphStyles>
  );
};

export default CircleGraph;
